import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { getComponentByRole, IComponetByRole } from 'src/app/helpers/component-by-role';
import { Roles } from 'src/app/models/enums';
import { AppState } from 'src/app/store/app.state';
import { ClubInterviewBroadcasterComponent } from '../club-interview-broadcaster/club-interview-broadcaster.component';
import { ClubInterviewClubComponent } from '../club-interview-club/club-interview-club.component';
import { ClubInterviewLeagueComponent } from '../club-interview-league/club-interview-league.component';

@Component({
  selector: 'app-club-interview-wrapper',
  templateUrl: './club-interview-wrapper.component.html'
})
export class ClubInterviewWrapperComponent implements OnInit {

  @ViewChild('dynamicComponent', { read: ViewContainerRef, static: true }) fixtureRef;
  interval: any;
  userInfo: Subscription;
  role: Roles;

  private components: IComponetByRole[] = [
    { role: Roles.League, component: ClubInterviewLeagueComponent},
    { role: Roles.Admin, component: ClubInterviewLeagueComponent},
    { role: Roles.Broadcaster, component: ClubInterviewBroadcasterComponent},
    { role: Roles.Club, component: ClubInterviewClubComponent}
  ];

  constructor(private componentFactoryResolver: ComponentFactoryResolver, private store: Store<AppState>) { }

  ngOnInit() {
    this.userInfo = this.store
      .select(state => state.user.currentUser)
      .subscribe(u => {
        if (u.role) {
          this.role = u.role;
          this.loadComponent(this.role);
        }
      });
  }

  loadComponent(role: Roles) {
    const factory = this.componentFactoryResolver.resolveComponentFactory(getComponentByRole(this.components, role));
    this.fixtureRef.clear();
    const ref = this.fixtureRef.createComponent(factory);
    ref.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    if (this.userInfo && this.userInfo.closed) {
      this.userInfo.unsubscribe();
    }
  }


}
